/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Button, Dialog, DialogContent, DialogTitle, LinearProgress, Typography } from '@mui/material';
import { LayoutBase } from '../../../layouts';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useEffect, useState, useMemo } from 'react';
import { ServicesRisrot } from '../../../services/api/reports/ReportsServicesRisrot';
import { formatDate, formatDateWhitoutHour, gerarPdfDeComponentes } from '../../../services/helpers/helpers';
import { ToolsDetails } from '../../../components/custom';
import { CustomAlert } from '../../../components/shared';

import { useAuthContext } from '../../../context';

import FichaRisrot from '../../../components/custom/Reports/Risrot/FichaRISROT';
import FichaEstruturas from '../../../components/custom/Reports/Risrot/FichaEstruturas';
import EstruturaAcesso from '../../../components/custom/Reports/Risrot/Estruturas/Acesso';
import EstruturaCrista from '../../../components/custom/Reports/Risrot/Estruturas/Crista';
import EstruturaTaludeMontante from '../../../components/custom/Reports/Risrot/Estruturas/TaludeMontante';
import EstruturaTaludeJusante from '../../../components/custom/Reports/Risrot/Estruturas/TaludeJusante';
import EstruturaOmbreiraDireita from '../../../components/custom/Reports/Risrot/Estruturas/OmbreiraDireita';
import EstruturaOmbreiraEsquerda from '../../../components/custom/Reports/Risrot/Estruturas/OmbreiraEsqurda';
import EstruturaReservatorio from '../../../components/custom/Reports/Risrot/Estruturas/Reservatorio';
import EstruturaTomadaAgua from '../../../components/custom/Reports/Risrot/Estruturas/Tomada';
import EstruturaVertedouro from '../../../components/custom/Reports/Risrot/Estruturas/Vertedouro';
import EstruturaDrenagemSuperficial from '../../../components/custom/Reports/Risrot/Estruturas/DrenagemSuperficial';
import EstruturaDrenagemInterna from '../../../components/custom/Reports/Risrot/Estruturas/DrenagemInterna';
import EstruturaInstrumentacao from '../../../components/custom/Reports/Risrot/Estruturas/Instrumentação';
import EstruturaSinalizacao from '../../../components/custom/Reports/Risrot/Estruturas/Sinalizacao';
import EstruturaAreaJusante from '../../../components/custom/Reports/Risrot/Estruturas/AreaJusante';
import { estruturaItensMap, estruturaTipos, type TypeEstruturas } from '../../../components/custom/Reports/Risrot/risrotEstruturaCatalog';
import {
	createRisrotInitialSituationSnapshot,
	getCanonicalRisrotItemLabel,
	getCanonicalRisrotStructureLabel,
	isSameRisrotItem,
	isSameRisrotStructure,
	mergeRisrotAnomaliasByStructure,
} from '../../../components/custom/Reports/Risrot/Estruturas/risrotEstruturaTableUtils';
import type { RisrotInitialSituationSnapshot } from '../../../components/custom/Reports/Risrot/Estruturas/risrotEstruturaTableUtils';

export { estruturaItensMap, estruturaTipos } from '../../../components/custom/Reports/Risrot/risrotEstruturaCatalog';
export type { TypeEstruturas } from '../../../components/custom/Reports/Risrot/risrotEstruturaCatalog';

export type TypeRisrot = {
	nome_estrutura: string;
	tipo_barramento: string;
	localizacao: string;
	empreendedor: string;
	codigo_cliente: string;
	codigo_hidrobr: string;
	data_ultima_inspecao: string;
	em_operacao: string;
	data_inspecao: string;
	hora_inicio_inspecao: string;
	hora_fim_inspecao: string;
	responsavel_inpecao: string;
	condicao_climatica: string;
	na_reservatorio: string;
	na_maximo_reservatorio: string;
	vertimento_extravasor: string;
	bombeamento_funcionando: string;
	executores_inspecao: string;
}

export type TypeAnomalias = {
	estrutura: string,
	detalhes: {
		uuid?: string;
		item: string,
		situacao: string,
		magnitude: string,
		data_inspecao: string,
		npa: string,
		observacoes_gerais: string,
		fluxo: string,
		codigo_anomalia?: string,
	}[];
	imagens: {
		data: string,
		date: string,
		legenda: string,
		nome: string
	}[],
}

export function RegisterRisrot() {

	const { id, risrot } = useParams();
	const navigate = useNavigate();
	const location = useLocation();

	const [disabled, setDisabled] = useState<boolean>(true);

	const [loadingSave, setLoadingSave] = useState<boolean>(false);
	const [loadingPrint, setLoadingPrint] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(false);
	const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info', key: string }>({
		open: false,
		message: '',
		severity: 'success',
		key: ''
	});
	const emptyAnomalias = useMemo<TypeAnomalias[]>(() => (
		Object.entries(estruturaItensMap).map(([estrutura, itens]) => ({
			estrutura,
			detalhes: itens.map((item) => ({
				item,
				situacao: '',
				magnitude: '',
				data_inspecao: '',
				npa: '',
				observacoes_gerais: '',
				fluxo: '',
			})),
			imagens: [],
		}))
	), []);

	const [estrutura, setEstrutura] = useState<TypeEstruturas | ''>('');
	const [risData, setRisData] = useState<TypeRisrot>({
		nome_estrutura: '',
		tipo_barramento: '',
		localizacao: '',
		empreendedor: '',
		codigo_cliente: '',
		codigo_hidrobr: '',
		data_ultima_inspecao: '',
		em_operacao: '',
		data_inspecao: '',
		hora_inicio_inspecao: '',
		hora_fim_inspecao: '',
		responsavel_inpecao: '',
		condicao_climatica: '',
		na_reservatorio: '',
		na_maximo_reservatorio: '',
		vertimento_extravasor: '',
		bombeamento_funcionando: '',
		executores_inspecao: ''
	});

	const [anomalias, setAnomalias] = useState<TypeAnomalias[]>(emptyAnomalias);
	const [initialSituationSnapshot, setInitialSituationSnapshot] = useState<RisrotInitialSituationSnapshot>(
		() => createRisrotInitialSituationSnapshot(emptyAnomalias),
	);

	const { userData } = useAuthContext();
	const [open, setOpen] = useState(false);
	const pagePermissionsString: string | undefined = useMemo(() => {
		return userData?.nivel_acesso?.registros?.RISROT;
	}, [userData]);

	const hasActionPermission = (action: 'add' | 'edit' | 'remove' | 'view'): boolean => {
		if (typeof pagePermissionsString === 'string' && pagePermissionsString !== '') {
			const actions = pagePermissionsString.split(',').map(s => s.trim());
			return actions.includes(action);
		}
		return false;
	};

	const isReadOnlyFinal = useMemo(() => {
		const isReadOnlyFromState = (location.state as { isReadOnlyMode?: boolean })?.isReadOnlyMode;

		return isReadOnlyFromState || !hasActionPermission('edit') || risrot !== 'new';
	}, [location.state, hasActionPermission]);


	function handleEstruturaSelecionada(value: TypeEstruturas) {
		setEstrutura(value);
	}

	const handleRisChange = (name: keyof TypeRisrot, value: string | boolean) => {

		setRisData(prevData => ({
			...prevData,
			[name]: value
		}));
	};

	function carregaEstrtura(estrutura: TypeEstruturas) {
		const isEstruturaDisabled = isReadOnlyFinal;
		const estruturaProps = {
			isView: risrot !== 'new',
			onUpdate: handleUpdateAnomalia,
			onAddItem: handleAddAnomaliaItem,
			onRemoveNewItem: handleRemoveNewAnomaliaItem,
			anomalias,
			initialSituationSnapshot,
			onUpdateImagens,
			disabled: isEstruturaDisabled,
			data_inspecao: risData.data_inspecao,
			hora_fim_inspecao: risData.hora_fim_inspecao,
		};
		switch (estrutura) {
			case 'Acesso':
				return <EstruturaAcesso {...estruturaProps} />;
			case 'Crista':
				return <EstruturaCrista {...estruturaProps} />;
			case 'Talude de montante':
				return <EstruturaTaludeMontante {...estruturaProps} />;
			case 'Talude de jusante':
				return <EstruturaTaludeJusante {...estruturaProps} />;
			case 'Ombreira Direita':
				return <EstruturaOmbreiraDireita {...estruturaProps} />;
			case 'Ombreira Esquerda':
				return <EstruturaOmbreiraEsquerda {...estruturaProps} />;
			case 'Reservatório':
				return <EstruturaReservatorio {...estruturaProps} />;
			case 'Tomada d\'água':
				return <EstruturaTomadaAgua {...estruturaProps} />;
			case 'Vertedouro':
				return <EstruturaVertedouro {...estruturaProps} />;
			case 'Sistema de drenagem superficial':
				return <EstruturaDrenagemSuperficial {...estruturaProps} />;
			case 'Drenagem interna / Dreno fundo':
				return <EstruturaDrenagemInterna {...estruturaProps} />;
			case 'Instrumentação':
				return <EstruturaInstrumentacao {...estruturaProps} />;
			case 'Sinalização':
				return <EstruturaSinalizacao {...estruturaProps} />;
			case 'Área de justante ao pé da barragem':
				return <EstruturaAreaJusante {...estruturaProps} />;
		}
	}

	const handleExportarPDF = async () => {
		if (!hasActionPermission('view')) {
			console.warn('Tentativa de exportar PDF sem permissão de "view".');
			return;
		}
		setLoadingPrint(true);
		const estruturas: TypeEstruturas[] = [
			'Acesso',
			'Crista',
			'Talude de montante',
			'Talude de jusante',
			'Ombreira Direita',
			'Ombreira Esquerda',
			'Reservatório',
			'Tomada d\'água',
			'Vertedouro',
			'Sistema de drenagem superficial',
			'Drenagem interna / Dreno fundo',
			'Instrumentação',
			'Sinalização',
			'Área de justante ao pé da barragem'
		];

		const response = await gerarPdfDeComponentes(estruturas, carregaEstrtura, <FichaRisrot handleUpdateNPGB={handleUpdateNPGB} maiorNPA={maiorNPA} onChange={handleRisChange} data={risData} disabled={isReadOnlyFinal} loadingData={loading} ristotID={risrot ?? ''} handleBuscaCabecalho={handleBuscaCabecalho} />);
		setLoadingPrint(response);
	};

	const [maiorNPA, setMaiorNPA] = useState<'Normal' | 'Alerta' | 'Atenção' | 'Emergência'>('Normal');

	const npaHierarquia: Record<'Normal' | 'Alerta' | 'Atenção' | 'Emergência', number> = {
		'Normal': 0,
		'Atenção': 1,
		'Alerta': 2,
		'Emergência': 3
	};

	function handleUpdateNPGB(value: string) {
		setMaiorNPA(value as 'Normal' | 'Alerta' | 'Atenção' | 'Emergência');
	}

	const calcularMaiorNPA = (
		detalhes: { npa?: 'Normal' | 'Atenção' | 'Alerta' | 'Emergência' }[]
	) => {
		return detalhes.reduce<'Normal' | 'Atenção' | 'Alerta' | 'Emergência'>(
			(maior, atual) =>
				atual.npa && npaHierarquia[atual.npa] > npaHierarquia[maior]
					? atual.npa
					: maior,
			'Normal'
		);
	};

	function handleUpdateAnomalia(
		estrutura: string,
		item: string,
		campo: keyof TypeAnomalias['detalhes'][0],
		valor: string
	) {
		if (isReadOnlyFinal) return;
		setAnomalias((prev) => {
			const updated = [...prev];
			const canonicalStructure = getCanonicalRisrotStructureLabel(estrutura);
			const canonicalItem = getCanonicalRisrotItemLabel(item, canonicalStructure);
			const estruturaIndex = updated.findIndex((a) => isSameRisrotStructure(a.estrutura, canonicalStructure));

			if (estruturaIndex === -1) {
				const nextAnomalias = [
					...updated,
					{
						estrutura: canonicalStructure,
						detalhes: [{
							item: canonicalItem,
							situacao: '',
							magnitude: '',
							data_inspecao: '',
							npa: '',
							observacoes_gerais: '',
							fluxo: '',
							[campo]: valor,
						} as TypeAnomalias['detalhes'][0]],
						imagens: []
					}
				];
				return mergeRisrotAnomaliasByStructure(nextAnomalias);
			}

			const detalhes = [...updated[estruturaIndex].detalhes];
			const itemIndex = detalhes.findIndex((d) => isSameRisrotItem(d.item, canonicalItem));

			if (itemIndex === -1) {
				detalhes.push({
					item: canonicalItem,
					situacao: '',
					magnitude: '',
					data_inspecao: '',
					npa: '',
					observacoes_gerais: '',
					fluxo: '',
					[campo]: valor,
				} as TypeAnomalias['detalhes'][0]);
			} else {
				detalhes[itemIndex] = {
					...detalhes[itemIndex],
					item: canonicalItem,
					[campo]: valor
				};
			}

			updated[estruturaIndex] = {
				...updated[estruturaIndex],
				estrutura: canonicalStructure,
				detalhes
			};

			if (campo === 'npa') {
				const todosDetalhes = updated.flatMap(a => a.detalhes) as {
					npa?: 'Normal' | 'Atenção' | 'Alerta' | 'Emergência';
				}[];
				const maior = calcularMaiorNPA(todosDetalhes);
				setMaiorNPA(maior);
			}

			return mergeRisrotAnomaliasByStructure(updated);
		});
	}

	function handleAddAnomaliaItem(estrutura: string, item: string) {
		if (isReadOnlyFinal) return;
		setAnomalias((prev) => {
			const canonicalStructure = getCanonicalRisrotStructureLabel(estrutura);
			const canonicalItem = getCanonicalRisrotItemLabel(item, canonicalStructure);
			const updated = [...prev];
			const estruturaIndex = updated.findIndex((anomalia) => isSameRisrotStructure(anomalia.estrutura, canonicalStructure));

			if (estruturaIndex === -1) {
				return mergeRisrotAnomaliasByStructure([
					...updated,
					{
						estrutura: canonicalStructure,
						detalhes: [{
							item: canonicalItem,
							situacao: '',
							magnitude: '',
							data_inspecao: '',
							npa: '',
							observacoes_gerais: '',
							fluxo: '',
						}],
						imagens: [],
					},
				]);
			}

			const detalhes = [...updated[estruturaIndex].detalhes];

			if (detalhes.some((detalhe) => isSameRisrotItem(detalhe.item, canonicalItem))) {
				return mergeRisrotAnomaliasByStructure(updated);
			}

			detalhes.push({
				item: canonicalItem,
				situacao: '',
				magnitude: '',
				data_inspecao: '',
				npa: '',
				observacoes_gerais: '',
				fluxo: '',
			});

			updated[estruturaIndex] = {
				...updated[estruturaIndex],
				estrutura: canonicalStructure,
				detalhes,
			};

			return mergeRisrotAnomaliasByStructure(updated);
		});
	}

	function handleRemoveNewAnomaliaItem(estrutura: string, item: string) {
		if (isReadOnlyFinal) return;
		setAnomalias((prev) => {
			const canonicalStructure = getCanonicalRisrotStructureLabel(estrutura);
			const canonicalItem = getCanonicalRisrotItemLabel(item, canonicalStructure);
			const updated = prev.map((anomalia) => {
				if (!isSameRisrotStructure(anomalia.estrutura, canonicalStructure)) {
					return anomalia;
				}

				return {
					...anomalia,
					estrutura: canonicalStructure,
					detalhes: anomalia.detalhes.filter((detalhe) => {
						if (!isSameRisrotItem(detalhe.item, canonicalItem)) {
							return true;
						}

						return Boolean(detalhe.uuid);
					}),
				};
			});

			return mergeRisrotAnomaliasByStructure(updated);
		});
	}

	const onUpdateImagens = (estrutura: string, imagens: TypeAnomalias['imagens']) => {
		if (isReadOnlyFinal) return;
		const canonicalStructure = getCanonicalRisrotStructureLabel(estrutura);

		setAnomalias((prev) =>
			mergeRisrotAnomaliasByStructure(prev.map((a) => {
				return isSameRisrotStructure(a.estrutura, canonicalStructure)
					? { ...a, estrutura: canonicalStructure, imagens }
					: a;
			}))
		);
	};


	const estruturasComData = anomalias.map((estrutura) => ({
		...estrutura,
		detalhes: estrutura.detalhes.map((d) => ({
			...d,
			data_inspecao: risData.data_inspecao,
		})),
	}));

	async function saveTeste() {
		setLoadingSave(true);
		if (!hasActionPermission('edit')) {
			setAlertInfo({ open: true, message: 'Você não tem permissão para editar este relatório.', severity: 'error', key: Date.now().toString() });
			return;
		}

		const anomaliasTratadas = estruturasComData.map(anomalia => {
			if (anomalia.imagens && anomalia.imagens.length > 0) {
				return {
					...anomalia,
					imagens: anomalia.imagens.filter(img => !img.data?.includes('https://s3.'))
				};
			}
			return anomalia;
		});

		const ficha = {
			...risData,
			npgb: maiorNPA,
			anomalias: anomaliasTratadas,
		};

		const response = await ServicesRisrot.create(ficha, id ?? '');
		if (response instanceof Error) {
			setAlertInfo({ open: true, message: 'Erro ao salvar RISROT: ' + response.message, severity: 'error', key: Date.now().toString() });
			setLoadingSave(false);
		} else {
			setAlertInfo({ open: true, message: 'RISROT salvo com sucesso!', severity: 'success', key: Date.now().toString() });
			setTimeout(() => {
				setLoading(false);
				setLoadingSave(false);
				navigate(-1);
			}, 1000);
		}
	}

	async function fetchData(uuid: string) {
		setLoading(true);
		const response = await ServicesRisrot.getCabecalho(uuid, risData.data_inspecao, risData.hora_inicio_inspecao, risData.hora_fim_inspecao);
		if (response instanceof Error) {
			setAlertInfo({ open: true, message: 'Erro ao buscar RISROT: ' + response.message, severity: 'warning', key: Date.now().toString() });
			setLoading(false);
		} else {

			setRisData({
				data_inspecao: risData.data_inspecao,
				hora_fim_inspecao: risData.hora_fim_inspecao,
				hora_inicio_inspecao: risData.hora_inicio_inspecao,
				nome_estrutura: response.nome_estrutura ?? '',
				tipo_barramento: response.tipo_barramento ?? '',
				localizacao: response.localizacao ?? '',
				empreendedor: response.empreendedor ?? '',
				codigo_cliente: response.codigo_cliente ?? '',
				codigo_hidrobr: response.codigo_hidrobr ?? '',
				data_ultima_inspecao: response.data_ultima_inspecao ?? '',
				em_operacao: response.em_operacao ?? '',
				responsavel_inpecao: response.responsavel_inpecao ?? '',
				condicao_climatica: response.condicao_climatica ?? '',
				na_reservatorio: response.na_reservatorio ?? '',
				na_maximo_reservatorio: response.na_maximo_reservatorio ?? '',
				vertimento_extravasor: response.vertimento_extravasor ?? '',
				bombeamento_funcionando: response.bombeamento_funcionando ?? '',
				executores_inspecao: risData.executores_inspecao ?? '',
			});
			setMaiorNPA(response.npgb ?? 'Normal');
			setDisabled(false);
			setLoading(false);
			if (Array.isArray(response.anomalias)) {
				if (response.anomalias.length > 0) {
					const nextAnomalias = mergeRisrotAnomaliasByStructure(response.anomalias);
					setAnomalias(nextAnomalias);
					setInitialSituationSnapshot(createRisrotInitialSituationSnapshot(nextAnomalias));
				} else {
					setAnomalias(emptyAnomalias);
					setInitialSituationSnapshot(createRisrotInitialSituationSnapshot(emptyAnomalias));
				}
			} else {
				setAnomalias(emptyAnomalias);
				setInitialSituationSnapshot(createRisrotInitialSituationSnapshot(emptyAnomalias));
				setLoading(false);
			}
		}
	}

	function toDate(date: string, time: string) {
		return new Date(`${date}T${time}`);
	}

	function imageToDate(dateTime: string) {
		return new Date(dateTime.replace(' ', 'T') + ':00');
	}


	async function fetchRis(uuid: string) {
		setLoading(true);
		const response = await ServicesRisrot.get(uuid);
		if (response instanceof Error) {
			setAlertInfo({ open: true, message: 'Erro ao buscar RISROT: ' + response.message, severity: 'warning', key: Date.now().toString() });
			setLoading(false);
		} else {
			setRisData({
				data_inspecao: response.data_inspecao,
				hora_fim_inspecao: response.hora_fim_inspecao,
				hora_inicio_inspecao: response.hora_inicio_inspecao,
				nome_estrutura: response.nome_estrutura ?? '',
				tipo_barramento: response.tipo_barramento ?? '',
				localizacao: response.localizacao ?? '',
				empreendedor: response.empreendedor ?? '',
				codigo_cliente: response.codigo_cliente ?? '',
				codigo_hidrobr: response.codigo_hidrobr ?? '',
				data_ultima_inspecao: response.data_ultima_inspecao ?? '',
				em_operacao: response.em_operacao ?? '',
				responsavel_inpecao: response.responsavel_inpecao ?? '',
				condicao_climatica: response.condicao_climatica ?? '',
				na_reservatorio: response.na_reservatorio ?? '',
				na_maximo_reservatorio: response.na_maximo_reservatorio ?? '',
				vertimento_extravasor: response.vertimento_extravasor ?? '',
				bombeamento_funcionando: response.bombeamento_funcionando ?? '',
				executores_inspecao: response.executores_inspecao ?? '',
			});
			setDisabled(false);
			setLoading(false);
			setMaiorNPA(response.npgb ?? 'Normal');
			if (Array.isArray(response.anomalias)) {
				if (response.anomalias.length > 0) {
					const inicio = toDate(
						response.data_inspecao,
						response.hora_inicio_inspecao
					);

					const fim = toDate(
						response.data_inspecao,
						response.hora_fim_inspecao
					);

					const anomaliasFiltradas = response.anomalias.map((anomalia: { imagens: any; }) => {
						const imagensFiltradas = (anomalia.imagens ?? []).filter((img: { date: string; }) => {
							const dataImagem = imageToDate(img.date);

							return (
								dataImagem >= inicio &&
								dataImagem <= fim
							);
						});

						return {
							...anomalia,
							imagens: imagensFiltradas
						};
					});
					const nextAnomalias = mergeRisrotAnomaliasByStructure(anomaliasFiltradas);
					setAnomalias(nextAnomalias);
					setInitialSituationSnapshot(createRisrotInitialSituationSnapshot(nextAnomalias));
				} else {
					setAnomalias(emptyAnomalias);
					setInitialSituationSnapshot(createRisrotInitialSituationSnapshot(emptyAnomalias));
				}
			} else {
				setAnomalias(emptyAnomalias);
				setInitialSituationSnapshot(createRisrotInitialSituationSnapshot(emptyAnomalias));
				setLoading(false);
			}
		}
	}

	useEffect(() => {
		// if (id && risrot === 'new' && risData.data_inspecao !== '') {
		// 	fetchData(id);
		// }
		if (risrot && risrot !== 'new') {
			fetchRis(risrot);
		}

		// if (risrot === 'new' && !loading) {
		// 	setDisabled(false);
		// }

	}, [id]);

	function handleBuscaCabecalho() {
		if (id && risrot === 'new' && risData.data_inspecao !== '' && risData.hora_fim_inspecao !== '' && risData.hora_inicio_inspecao !== '') {
			fetchData(id);
		}
	}

	useEffect(() => {
		if (disabled === false && risrot === 'new') {
			setAlertInfo({ open: true, message: 'Busque novamente o último relatório!', severity: 'info', key: Date.now().toString() });
			setDisabled(true);
		}
	}, [risData.data_inspecao, risData.hora_fim_inspecao, risData.hora_inicio_inspecao]);

	return (
		<LayoutBase
			title='Registro RISROT'
			tollBar={
				<ToolsDetails
					showSaveButton={pagePermissionsString?.includes('add') && risrot === 'new'}
					onClickSave={() => setOpen(true)}
					loading={loadingSave}
					// showPrintButton={hasActionPermission('view')} 
					onClickPrint={handleExportarPDF}
					loadingPrint={loadingPrint}
					disableSave={loadingSave || risData.data_inspecao === '' || risData.hora_fim_inspecao === '' || risData.hora_inicio_inspecao === ''}
					showDeletButton={false}
					showNewButton={false}
				/>
			}
		>
			<Box>
				<FichaRisrot
					handleUpdateNPGB={handleUpdateNPGB}
					onChange={handleRisChange}
					data={risData}
					disabled={disabled}
					loadingData={loading}
					ristotID={risrot ?? ''}
					handleBuscaCabecalho={handleBuscaCabecalho}
					maiorNPA={maiorNPA}
				/>
				<FichaEstruturas
					onSelect={handleEstruturaSelecionada}
					selectValue={estrutura}
					disabled={disabled}
				/>
				{loading === true && <LinearProgress />}

				{estrutura !== '' && disabled == false &&
					carregaEstrtura(estrutura)
				}
			</Box>
			{alertInfo.open &&
				<CustomAlert
					message={alertInfo.message}
					severity={alertInfo.severity}
					key={alertInfo.key}
				/>
			}

			<Dialog open={open} onClose={() => setOpen(false)}>
				<DialogTitle>Confirmação</DialogTitle>
				<DialogContent>
					<Typography style={{marginBottom: 2}}><strong>A data de inspeção do documento esta correta ?</strong></Typography>
					<Typography><strong>Data:</strong> {formatDateWhitoutHour(risData.data_inspecao)}</Typography>
					<Typography><strong>Hora início:</strong> {risData.hora_inicio_inspecao}</Typography>
					<Typography><strong>Hora fim:</strong> {risData.hora_fim_inspecao}</Typography>
					<div style={{display: 'flex', justifyContent: 'space-around', marginTop: 5 ,  flexDirection: 'row', gap: 2}}>
						<Button fullWidth variant='contained' color='success' onClick={() => saveTeste()} disabled={loadingSave}>SIM</Button>	
						<Button fullWidth variant='contained' color='error' onClick={() => setOpen(false)}>NÂO</Button>
					</div> 
				</DialogContent>
			</Dialog>
		</LayoutBase>
	);
}
